import React from 'react';

import { FormControl, Input } from '@mui/material';

import { DOWN_PAYMENT } from '../../constants/LoansCalculator/AutoLoans';

import './DownPaymentInput.css';

export const DownPaymentInput = ({ downPaymentValue, onDownPaymentChange }) => {
  return (
    <div className="loans-financing-field-wrapper">
      <p className="downpayment-label">{DOWN_PAYMENT}</p>
      <FormControl
        sx={{
          width: '100%',
        }}
      >
        <Input
          id="downpayment-financing-select-helper"
          value={downPaymentValue || ''}
          placeholder={DOWN_PAYMENT}
          autoComplete="off"
          onChange={(e) => {
            if (!isNaN(e.target.value)) {
              onDownPaymentChange(e.target.value);
            } else {
              onDownPaymentChange('');
            }
          }}
          disableUnderline
        />
      </FormControl>
    </div>
  );
};
